<template>
  <div class="contact">
    <nav-bar></nav-bar>
    <div class="container second-container popup">
      <span v-if="isEmailSentSuccessfully" class="popuptext" id="succesEmailPopup" style="background-color: green">Email
        sent successfully</span>
      <span v-if="isEmailSentSuccessfully == false" class="popuptext" id="unsuccesfullEmailPopup"
        style="background-color: red">Faild to sent email</span>
      <div class="hero-body">
        <div class="columns is-vcentered custom-vertical-space">
          <div class="column is-12"></div>
        </div>
        <div class="columns">
          <div class="column is-10-fullhd is-offset-1-fullhd products-title">
            <div class="content">
              <h1 class="is-uppercase has-text-centered has-text-primary">
                {{ texts.title }}
              </h1>
            </div>
          </div>
        </div>
        <form ref="contactForm" class="contactFormContainer" v-on:submit.prevent="onSubmit()" method="POST"
          action="../contact.php">
          <textarea class="is-hidden" type="hidden" id="recaptcha-responseContact"
            name="g-recaptcha-response"></textarea>
          <div class="columns">
            <div v-if="selectedProduct" class="column is-2 is-hidden-touch is-hidden-desktop-only"></div>
            <div v-if="selectedProduct" class="column">
              <div class="productDetails">
                <div class="product-card">
                  <div class="offer has-text-weight-semibold is-uppercase has-text-primary">
                    {{ textsProducts.priceRequest }}
                  </div>
                  <h3 class="productName has-text-weight-bold is-centered mb-5 has-text-primary">
                    {{ selectedProduct.multilingualName == true ? textsExtraOptions.products[selectedProduct.model] : selectedProduct.model }}
                    <!-- {{ selectedProduct.model }} -->
                  </h3>

                  <div class="card-image-container">
                    <figure class="image" :class="selectedProduct.isSquareImage == true ? 'is-1by1' : 'is-5by3'">
                      <img class="card-image" @click="$refs.galeria.open(imagesIndexes[index])"
                        :src="`${publicPath}${selectedProduct.img}`" />
                    </figure>
                  </div>
                  <div class="cardContent">
                    <div class="card-details">
                      <div v-if="selectedProduct.cargo_dimensions" class="cardData loadingSurface">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/rakodasi_felulet.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.cargo_dimensions }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ selectedProduct.onlyDeck ? textsProducts.dimension : textsProducts.cargoDimensions }}
                        </div>
                      </div>

                      <div v-if="selectedProduct.axles" class="cardData axes">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/tengelyek_szama.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.axles }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.axles }}
                        </div>
                      </div>

                      <div v-if="selectedProduct.total_length" class="cardData totalLength">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/ossz_hossz.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.total_length }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.totalLength }}
                        </div>
                      </div>

                      <div v-if="selectedProduct.maximum_authorized_mass" class="cardData weight">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/osszsuly.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.maximum_authorized_mass }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.maximumAuthorizedMass }}
                        </div>
                      </div>

                      <div v-if="selectedProduct.own_mass" class="cardData ownMass">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/onsuly.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.own_mass }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.ownMass }}
                        </div>
                      </div>

                      <div v-if="selectedProduct.loading_capacity" class="cardData loadingCapacity">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/teherbiras.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          {{ selectedProduct.loading_capacity }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.loadingCapacity }}
                        </div>
                      </div>

                      <div class="cardData price">
                        <div class="cardLabel">
                          <img class="detailLogo" src="../assets/images/products/ar.svg" alt="" />
                        </div>
                        <div class="detailValue has-text-weight-bold has-text-primary">
                          € {{ selectedProduct.price }}
                        </div>
                        <div class="detailLabel has-text-primary">
                          {{ textsProducts.price }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column" :class="selectedProduct
                ? ''
                : 'is-6-tablet is-4-desktop is-offset-3-tablet is-offset-4-desktop'
              ">
              <div class="field">
                <label class="label has-text-primary">{{
                  texts.fullName
                }}</label>
                <div class="control">
                  <input class="input" type="text" name="name" placeholder="" v-model="name"
                    :class="validName == false ? 'error-border' : ''" />
                </div>
              </div>

              <div class="field">
                <label class="label has-text-primary">{{ texts.email }}</label>
                <div class="control">
                  <input v-model="email" class="input" type="email" name="email" placeholder=""
                    :class="validEmail == false ? 'error-border' : ''" />
                </div>
              </div>

              <div class="field">
                <label class="label has-text-primary">{{ texts.phone }}</label>
                <div class="control">
                  <input v-model="phone" class="input" type="phone" name="phone" placeholder=""
                    :class="validPhone == false ? 'error-border' : ''" />
                </div>
              </div>

              <div class="field">
                <label class="label has-text-primary">{{
                  texts.message
                }}</label>
                <div class="control">
                  <textarea v-model="message" class="textarea" name="message" placeholder=""
                    :class="validMessage == false ? 'error-border' : ''"></textarea>
                </div>
              </div>
              <input class="is-hidden" type="text" name="trailer" v-model="selectedProductModelName" />
              <div class="field mt-4">
                <div class="field-label">
                  <!-- Left empty for spacing -->
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control has-text-centered">
                      <button type="submit" class="button is-primary is-rounded is-uppercase has-text-weight-bold">
                        {{ texts.send }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="recaptchaPolicy has-text-centered mt-6 has-text-primary">
                  {{ texts.recaptcha.protectedBy }}
                  <a class="has-text-primary" href="https://policies.google.com/privacy" target="_blank">{{
                    texts.recaptcha.privacyPolicy }}</a>
                  {{ texts.recaptcha.and }}
                  <a class="has-text-primary" href="https://policies.google.com/terms" target="_blank">{{
                    texts.recaptcha.termsOfService }}</a>
                  {{ texts.recaptcha.apply }}.
                </div>
              </div>
            </div>
            <div v-if="selectedProduct" class="column is-2 is-hidden-touch is-hidden-desktop-only"></div>
          </div>
        </form>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>


<script>
import NavBar from "./Navbar.vue";
import AppFooter from "./AppFooter.vue";
import axios from "axios";

export default {
  name: "Contact",
  data() {
    return {
      selectedProduct: this.$store.state.selectedProduct,
      publicPath: process.env.BASE_URL,
      message: "",
      loading: true,
      name: "",
      email: "",
      phone: "",
      validEmail: null,
      validName: null,
      validPhone: null,
      validMessage: null,
      isSuccess: false,
      isEmailSentSuccessfully: null,
    };
  },
  mounted() {
    if (window.location.href.indexOf("successEmailSent") > -1) {
      console.log("sucessss");
      this.isEmailSentSuccessfully = true;
      // succesEmailMessage();
    } else if (window.location.href.indexOf("errorMailSent") > -1) {
      console.log("unsuccess");
      this.isEmailSentSuccessfully = false;
    }
  },
  destroyed() {
    this.$store.dispatch("saveSelectedProduct", null);
  },
  components: {
    NavBar: NavBar,
    AppFooter: AppFooter,
  },
  computed: {
    texts() {
      return this.$t("contact");
    },
    textQA() {
      return this.$t("faq.qas");
    },
    textsProducts() {
      return this.$t("products.general");
    },
    textsExtraOptions() {
      return this.$t("products.extraOptions");
    },
    selectedProductModelName() {
      return this.selectedProduct ? this.selectedProduct.model : "no_model";
    },
  },
  methods: {
    onSubmit() {
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("message", this.message);

      this.validateName(this.name);
      this.validateEmail(this.email);
      this.validatePhone(this.phone);
      this.validateMessage(this.message);

      // console.log('this.validName',this.validName)
      // console.log('this.validEmail',this.validEmail)
      // console.log('this.validMessage',this.validMessage)

      if (
        this.validName &&
        this.validEmail &&
        this.validMessage &&
        this.validPhone
      ) {
        console.log("form is valid");
        this.$recaptcha("login").then((token) => {
          document.getElementById("recaptcha-responseContact").value = token;
          // console.log("token> ", token);
          this.$refs.contactForm.submit();
        });
      }
    },
    validateEmail(value) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      reg.test(value) ? (this.validEmail = true) : (this.validEmail = false);
    },
    validateName(value) {
      value.length >= 1 ? (this.validName = true) : (this.validName = false);
    },
    validatePhone(value) {
      value.length >= 1 ? (this.validPhone = true) : (this.validPhone = false);
    },
    validateMessage(value) {
      value.length >= 1
        ? (this.validMessage = true)
        : (this.validMessage = false);
    },
  },

  watch: {
    email(value) {
      // binding this to the data value in the email input
      this.validateEmail(value);
      // console.log(this.validEmail)
    },
    isEmailSentSuccessfully() {
      console.log(
        "this.isEmailSentSuccessfully elotte",
        this.isEmailSentSuccessfully
      );
      setTimeout(() => {
        this.isEmailSentSuccessfully = null;
      }, 5000);
      console.log(
        "this.isEmailSentSuccessfully utana",
        this.isEmailSentSuccessfully
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  .container.second-container {
    min-height: calc(100vh - 137px - 269px - 33px);

    .contactFormContainer {
      margin: 2rem 0 3rem;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-fill-color: white;
    }

    input,
    textarea {
      border: 2px solid rgba(61, 120, 130, 0.2);
      background-color: white;
    }

    input.error-border,
    textarea.error-border {
      border-color: red;
    }

    .input:active,
    .textarea:active,
    .input:focus,
    .textarea:focus {
      border: 2px solid rgba(61, 120, 130, 0.2);
      box-shadow: none;
    }

    button {
      margin-top: 1.5rem;
      padding: 1.2rem 1.5rem;
      font-size: 15px;
    }

    .productDetails {
      border-radius: 12px;
      padding: 1.7rem;
      background-color: rgba(61, 120, 130, 0.08);

      .offer {
        font-size: 20px;
        margin-bottom: 1.7rem;
      }

      .product-card {
        .card-image-container {
          border-radius: 12px;
          margin: 1.8rem 0;

          .card-image {
            border-radius: 4px;
          }
        }

        .cardData {
          display: flex;
          margin: 1rem 0;
        }

        .cardData:last-child {
          margin: 1rem 0 0 0;
        }

        .detailLabel {
          text-transform: lowercase;
        }

        .detailValue {
          margin: 0 0.5rem;
        }
      }
    }
  }

  .recaptchaPolicy {
    font-size: 0.85rem;
    max-width: 416px;
    text-align: center;
    margin: 0 auto;
    margin-top: 2rem;

    a {
      font-weight: 600;
    }
  }
}

@media (max-width: 600px) {
  .contact {
    .container.second-container {
      min-height: calc(100vh - 137px - 269px - 33px);

      .contactFormContainer {
        margin: 2rem 0 3rem;
      }

      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-fill-color: white;
      }

      input,
      textarea {
        border: 2px solid rgba(61, 120, 130, 0.2);
        background-color: white;
      }

      .input:active,
      .textarea:active,
      .input:focus,
      .textarea:focus {
        border: 2px solid rgba(61, 120, 130, 0.2);
        box-shadow: none;
      }

      button {
        margin-top: 1.5rem;
        padding: 1.2rem 1.5rem;
        font-size: 15px;
      }

      .productDetails {
        border-radius: 12px;
        padding: 1.5rem 0.8rem;
        background-color: rgba(61, 120, 130, 0.08);

        .offer {
          font-size: 18px;
          margin-bottom: 1.2rem;
        }

        .product-card {
          .card-image-container {
            border-radius: 12px;
            margin: 1.8rem 0;

            .card-image {
              border-radius: 4px;
            }
          }

          .cardData {
            display: flex;
            margin: 0.75rem 0;
          }

          .detailLogo {
            width: 20px;
            height: auto;
          }

          .cardData:last-child {
            margin: 1rem 0 0 0;
          }

          .detailLabel {
            text-transform: lowercase;
            font-size: 0.75rem;
          }

          .detailValue {
            margin: 0 0.5rem;
            font-size: 0.75rem;
          }
        }
      }
    }
  }
}

//Popup
.popup {
  position: relative;
  // cursor: pointer;
  // -webkit-user-select: none;
  // -moz-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
}

/* The actual popup */
.popup .popuptext {
  // visibility: hidden;
  width: 250px;
  background-color: green;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 3%;
  opacity: 0.8;
}
</style>